
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MOZ_EvBookingBooker.html?raw';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
class MOZ_EvBookingBooker extends compose(_StatefulSection) {
    templateString: any = template;

    bookerInput: MdsLax<InstanceType<typeof SearchSelect>>;
    bookerSubstituteInput: MdsLax<InstanceType<typeof SearchSelect>>;

    protected afterSetData() {
        let data = this.currentData as VAM2types.EvBookingBooker;


    }

    protected afterReady() {
        console.log("Moz-Booker: afterReady");

        if (this.hasFeature("Mozarteum/Booker")) {
            if (this.sourceData == null) {
                this.bookerInput.setValue(window.sessionInfo?.sessionData?.CurrentEmployeeId, true);
            }
            this.bookerInput.setCallfunction("Webtool_API_EvBooking__GetBookerListValues");
            this.bookerInput.loadListValues();

            //this.bookerSubstituteInput.setValue(window.sessionInfo?.sessionData?.CurrentEmployeeId, true);
            this.bookerSubstituteInput.setCallfunction("Webtool_API_EvBooking__GetBookerListValues");
            setTimeout(lang.hitch(this.bookerSubstituteInput, this.bookerSubstituteInput.loadListValues ), 1000);
            
        }
    }

    protected onDirtyChange(currentState: boolean) {
        let data = this.currentData as VAM2types.EvBookingBooker;
    }

    protected _onChanged(key: string, value: any) {
        // wird bei jedem onchanged aufgerufen
        let data = this.currentData as VAM2types.EvBookingBooker;
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        //console.debug(this.id + " startup, Feature?", this.hasModule("EvBooking/Booker"));

        
    }
}

export default mdsWidget(MOZ_EvBookingBooker);